export const SMARTCAF_URL = 'https://www.smartcaf.it'

export const AGENZIA_ENTRATE_URL =
  'https://www.agenziaentrate.gov.it/portale/regione-friuli-venezia-giulia-dip'

export const MINISTERO_LAVORO_URL =
  'https://www.lavoro.gov.it/temi-e-priorita/previdenza/focus-on/vigilanza-istituti-patronato/pagine/istituti-di-patronato'

const apiHost = process.env.NEXT_PUBLIC_HOST?.replace(/\/$/, '')

export const CAF_AUTHORIZATION_PDF = `${apiHost}/authorizations/caf`

export const PATRONATO_AUTHORIZATION_PDF = `${apiHost}/authorizations/patronato`

export const AGENZIA_ENTRATE_AUTHORIZATION_PDF = `${apiHost}/authorizations/agenzia-entrate`

const footerAuthorityLinks = [
  { label: 'Smartcaf.it', href: SMARTCAF_URL },
  { label: 'Agenzia delle Entrate', href: AGENZIA_ENTRATE_URL, opensInNewTab: true },
  {
    label: 'Ministero del Lavoro e delle Politiche Sociali',
    href: MINISTERO_LAVORO_URL,
    opensInNewTab: true,
  },
  {
    label: 'Ministerio de Trabajo y Políticas Sociales',
    href: MINISTERO_LAVORO_URL,
    opensInNewTab: true,
  },
  {
    label: 'وزارة العمل والسياسات الاجتماعية',
    href: MINISTERO_LAVORO_URL,
    opensInNewTab: true,
  },
]

const withAuthorityLinks = (parts, authorityLink) =>
  parts.flatMap((part) => {
    const isPlainText = typeof part === 'string'
    const containsAuthorityLabel = isPlainText && part.includes(authorityLink.label)

    if (!containsAuthorityLabel) {
      return [part]
    }

    const segments = part.split(authorityLink.label)

    return segments.flatMap((segment, index) => {
      const isLastSegment = index === segments.length - 1
      const hasSegmentText = segment.length > 0
      const textSegment = hasSegmentText ? [segment] : []

      if (isLastSegment) {
        return textSegment
      }

      return [...textSegment, authorityLink]
    })
  })

export const getFooterDescriptionParts = (description) =>
  footerAuthorityLinks.reduce(withAuthorityLinks, [description])

const italianFooterDescription =
  "Smartcaf.it è un servizio offerto da Smart Services S.r.l., società di servizi autorizzata dall'Agenzia delle Entrate all'accesso al canale telematico Entratel (tipologia utente E20 - Consulente fiscale abituale, ai sensi dell'art. 3 del D.P.R. n. 322/1998 per la presentazione delle dichiarazioni, registrazione contratti di locazione e comunicazioni telematiche), nonché Partner autorizzato di CAF CGN S.p.A. (Albo n. 73), autorizzato dall'Agenzia delle Entrate, e del Patronato FENAPI, autorizzato dal Ministero del Lavoro e delle Politiche Sociali."

const spanishFooterDescription =
  'Smartcaf.it es un servicio ofrecido por Smart Services S.r.l., sociedad de servicios autorizada por la Agenzia delle Entrate para el acceso al canal telemático Entratel (tipología de usuario E20 - Consultor fiscal habitual, conforme al art. 3 del D.P.R. n. 322/1998 para la presentación de las declaraciones, el registro de contratos de arrendamiento y las comunicaciones telemáticas), así como Partner autorizado de CAF CGN S.p.A. (Albo n. 73), autorizado por la Agenzia delle Entrate, y del Patronato FENAPI, autorizado por el Ministerio de Trabajo y Políticas Sociales.'

const arabicFooterDescription =
  'Smartcaf.it هي خدمة تقدمها Smart Services S.r.l.، شركة خدمات مرخّصة من Agenzia delle Entrate للوصول إلى القناة الإلكترونية Entratel (فئة المستخدم E20 - مستشار ضريبي معتاد، بموجب المادة 3 من المرسوم الرئاسي رقم 322/1998 لتقديم الإقرارات وتسجيل عقود الإيجار والاتصالات الإلكترونية)، وكذلك شريك معتمد لـ CAF CGN S.p.A. (السجل رقم 73)، مرخّص من Agenzia delle Entrate، ومن Patronato FENAPI، المرخّص من وزارة العمل والسياسات الاجتماعية.'

const footerCopy = {
  it: {
    description: italianFooterDescription,
    quickLinks: 'Link Veloci',
    aboutUs: 'Chi siamo',
    revokeForm: 'Modulo Revoca',
    blog: 'Blogs',
    infoTitle: 'Informazioni',
    faq: 'FAQ',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
    terms: 'Termini e condizioni',
    manualeFea: 'Manuale Operativo FEA',
    authorizationsTitle: 'Autorizzazioni',
    caf: 'CAF',
    patronato: 'Patronato',
    agenziaEntrate: 'Agenzia delle Entrate',
    consultationTitle: 'Una consulenza veloce?',
    contactUsTitle: 'Contattaci',
    address: 'Via pola 11, 20124 milano',
    copyright: 'copyright © 2010-{{year}} smartcaf company all rights reserved.',
  },
  es: {
    description: spanishFooterDescription,
    quickLinks: 'Enlaces rapidos',
    aboutUs: 'Quienes somos',
    revokeForm: 'Formulario de revocacion',
    blog: 'Blogs',
    infoTitle: 'Informaciones',
    faq: 'FAQ',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
    terms: 'Terminos y condiciones',
    manualeFea: 'Manual operativo FEA',
    authorizationsTitle: 'Autorizaciones',
    caf: 'CAF',
    patronato: 'Patronato',
    agenziaEntrate: 'Agencia Tributaria',
    consultationTitle: 'Una consulta rapida?',
    contactUsTitle: 'Contactanos',
    address: 'Via pola 11, 20124 milano',
    copyright: 'copyright © 2010-{{year}} smartcaf company all rights reserved.',
  },
  ar: {
    description: arabicFooterDescription,
    quickLinks: 'روابط سريعة',
    aboutUs: 'من نحن',
    revokeForm: 'نموذج الإلغاء',
    blog: 'المدونة',
    infoTitle: 'معلومات',
    faq: 'الأسئلة الشائعة',
    privacyPolicy: 'سياسة الخصوصية',
    cookiePolicy: 'سياسة ملفات الارتباط',
    terms: 'الشروط والأحكام',
    manualeFea: 'دليل التشغيل FEA',
    authorizationsTitle: 'التراخيص',
    caf: 'CAF',
    patronato: 'الباتروناتو',
    agenziaEntrate: 'وكالة الإيرادات',
    consultationTitle: 'استشارة سريعة؟',
    contactUsTitle: 'تواصل معنا',
    address: 'Via pola 11, 20124 milano',
    copyright: 'copyright © 2010-{{year}} smartcaf company all rights reserved.',
  },
}

export const getFooterCopy = (locale) => footerCopy[locale] || footerCopy.it